import React from 'react';
import PropTypes from 'prop-types';

const ToggleRevealTextarea = ({
  value,
  onChange,
  onRemove,
  onAdd,
  label,
  addLabel,
  placeholder,
  rows,
  visible,
}) => {
  const isVisible = visible !== undefined ? visible : value != null;

  if (!isVisible) {
    return (
      <a href="#"
         onClick={(e) => { e.preventDefault(); onAdd(); }}
         className="text-primary">
        <strong><i className="fal fa-plus"></i> {addLabel || `Add ${label}`}</strong>
      </a>
    );
  }

  return (
    <div>
      <div className="d-flex align-items-center justify-content-between">
        <label className="text-muted mb-0" style={{ fontSize: 14, fontWeight: 500 }}>{label}</label>
        <a href="#"
           onClick={(e) => { e.preventDefault(); onRemove(); }}
           style={{ fontSize: '12px', color: '#999', textDecoration: 'none' }}>
          <i className="fal fa-times" style={{ marginRight: '4px' }}></i>Remove
        </a>
      </div>
      <textarea
        className="form-control"
        rows={rows || 2}
        placeholder={placeholder}
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        onBlur={(e) => {
          const trimmed = e.target.value.trim();
          if (trimmed !== e.target.value) onChange(trimmed);
        }}
        style={{ fontSize: '14px' }}
      />
    </div>
  );
};

ToggleRevealTextarea.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  onAdd: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  addLabel: PropTypes.string,
  placeholder: PropTypes.string,
  rows: PropTypes.number,
  visible: PropTypes.bool,
};

export default ToggleRevealTextarea;
